var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdtLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_33365)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 18C4.02919 18 0 13.9708 0 9C0 4.02919 4.02919 0 9 0C13.9708 0 18 4.02919 18 9C18 13.9708 13.9708 18 9 18ZM10.0811 7.75856V6.42769H13.1265V4.39819H4.83469V6.42769H7.88006V7.758C5.40506 7.87162 3.54375 8.36212 3.54375 8.94938C3.54375 9.53662 5.40506 10.0266 7.88006 10.1407V14.4056H10.0811V10.1396C12.5522 10.026 14.409 9.53606 14.409 8.94938C14.409 8.36269 12.5522 7.87275 10.0811 7.75856ZM10.0811 9.77794V9.77681C10.0193 9.78131 9.70031 9.80044 8.98875 9.80044C8.42062 9.80044 8.02069 9.78356 7.88006 9.77681V9.7785C5.69306 9.68231 4.06069 9.3015 4.06069 8.84587C4.06069 8.39081 5.69306 8.01 7.88006 7.91213V9.39937C8.02294 9.4095 8.43244 9.43369 8.99831 9.43369C9.67725 9.43369 10.0176 9.40556 10.0811 9.39994V7.91325C12.2636 8.01056 13.8921 8.39137 13.8921 8.84587C13.8921 9.3015 12.2636 9.68119 10.0811 9.77794Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_33365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdtLight);
export default __webpack_public_path__ + "static/media/USDT_LIGHT.a35381684ec0dd976fca01cc228133a6.svg";
export { ForwardRef as ReactComponent };